<template>
  <Modal
    modal-id="flight-and-hotel"
    :is-open="showModal"
    modal-class="warning-flight-and-hotel-modal modal--bottom"
    :modal-title="props.i18n.flight_hotel_modal.title"
    @close="closeFlightAndHotelModal"
  >
    <template #content>
      <div class="warning-flight-and-hotel-modal__text">
        <p class="warning-flight-and-hotel-modal__title t-h2">
          {{ props.i18n.flight_hotel_modal.title }}
        </p>
        <p class="warning-flight-and-hotel-modal__subtitle mt-2">
          {{ props.i18n.flight_hotel_modal.subtitle }}
        </p>
        <p class="warning-flight-and-hotel-modal__extra mt-3">
          {{ props.i18n.flight_hotel_modal.extra }}
        </p>
      </div>
      <div class="warning-flight-and-hotel-modal__buttons mt-4">
        <button
          class="secondary-btn"
          tabindex="0"
          @keydown.enter.stop.prevent="handleDisagreement"
          @click="handleDisagreement"
        >
          {{ props.i18n.flight_hotel_modal.reject_button }}
        </button>
        <a class="btn-primary" tabindex="0" @keydown.enter="handleAccept" @click="handleAccept">
          {{ props.i18n.flight_hotel_modal.accept_button }}
        </a>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { currentDevice } from '../../../../core/utils/currentDevice'
import Modal from '../Modal/Modal.vue'

// --- PROPS & EMITS ---
const props = defineProps({
  i18n: {
    type: Object,
    default: () => {},
  },
  showModal: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close', 'accept', 'cancel'])

function closeFlightAndHotelModal() {
  window.Modal.close('flight-and-hotel')
  emit('close')
}

function handleAccept() {
  emit('accept')
  closeFlightAndHotelModal()
}

function handleDisagreement() {
  emit('cancel')
  closeFlightAndHotelModal()
}

if (currentDevice.isMobile) {
  import('../../../../elements/fastbooking_flight_and_hotel_modal/fastbooking_flight_and_hotel_modal_mobile.scss')
} else {
  import('../../../../elements/fastbooking_flight_and_hotel_modal/fastbooking_flight_and_hotel_modal.scss')
}

function handleCloseModal() {
  closeFlightAndHotelModal()
}
</script>

<style lang="scss">
@use '../../../../base_css/abstracts/abstracts.scss' as *;

.fb-tabs {
  position: relative;
  z-index: 8;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: -1px;

  &__tab {
    position: relative;
    cursor: pointer;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    padding: 10px 30px;
    background-color: var(--c_grey_100);
    color: var(--c_grey_600);
    font-weight: bold;
    font-size: 14px;
  }

  &__icon {
    font-size: 24px;
  }
}

.btn-primary {
  cursor: pointer;
}

@include commonTabletDesktop {
  .fb-tabs {
    &__tab {
      &--active {
        background-color: var(--c_white);
        color: var(--c_turquoise);
      }
    }
  }
}

@include mobileStyles {
  .fb-tabs {
    &__tab {
      width: 50%;
      padding: 10px 0;
      border: 1px solid var(--c_grey);
      border-top: 2px solid transparent;
      font-size: 12px;
      text-transform: uppercase;

      &--active {
        border: none;
        border-top: 2px solid var(--c_dark_grey);
        background-color: var(--c_white);
        color: var(--c_dark_grey);
      }
    }
  }
}
</style>
